'use strict';

angular.module('angular-parallax', [
]).directive('parallax', ['$window', function($window) {
    return {
        restrict: 'A',
        scope: {
            parallaxRatio: '@',
            parallaxVerticalOffset: '@',
            parallaxHorizontalOffset: '@',
            parallaxHorizontalRatio: "@",
            parallaxLockOffset: "=",
            parallaxEnabled: "="
        },
        link: function($scope, elem, attrs) {
            var inv = function(val) {
                    return ("parallaxHorizontalInvert" in attrs) ? 100 - val : val;
                },
                locked = false,
                bind = false;

            var setPosition = function () {

                if (!locked) {
                    requestAnimationFrame(function(){
                        var win = $window.pageYOffset,
                            elementPos = angular.element(elem).offset().top;

                        if (!$scope.parallaxHorizontalOffset) $scope.parallaxHorizontalOffset = '0';

                        var css = {
                            X:'0',
                            Y:'0'
                        };

                        if ($scope.parallaxRatio) {
                            var calcValY = Math.round(-( elementPos - $window.pageYOffset ) * ($scope.parallaxRatio ? $scope.parallaxRatio : 1.1 ));
                            if (calcValY <= $window.innerHeight) {
                                var topVal = (calcValY < $scope.parallaxVerticalOffset ? $scope.parallaxVerticalOffset : calcValY);

                                css.Y = topVal + 'px';
                            }
                        }

                        if ($scope.parallaxHorizontalRatio) {
                            if ( elementPos > win - angular.element(elem).height() && elementPos < ( win + $window.innerHeight + angular.element(elem).height() )) {

                                var initialHozVal = 100 - ( ( elementPos - win ) / $window.innerHeight ) * 100;
                                var hozVal = initialHozVal * ( $scope.parallaxHorizontalRatio ? $scope.parallaxHorizontalRatio : 1 );

                                css.X = inv(hozVal) + '%';
                            } else if (!(elementPos <= win - angular.element(elem).height())) {
                                css.X = inv(0) + '%';
                            } else {
                                css.X = inv(100) * ( $scope.parallaxHorizontalRatio ? $scope.parallaxHorizontalRatio : 1 ) + '%';
                            }
                        }

                        if ($scope.parallaxLockOffset) {
                            if ($window.pageYOffset > $scope.parallaxLockOffset) {
                                locked = true;
                            }
                        }

                        elem.css('transform', 'translate3d('+css.X+', '+css.Y+', 0)');
                    });
                }

            };


            $scope.$watch('parallaxEnabled', function(newV, oldV){

                if (typeof newV === 'undefined' || newV == true) {
                    setPosition();
                    angular.element($window).bind("scroll", setPosition);
                    angular.element($window).bind("touchmove", setPosition);
                    bind = true;
                } else {
                    if (bind === true) {
                        angular.element($window).unbind("scroll", setPosition);
                        angular.element($window).unbind("touchmove", setPosition);
                    }
                }
            });


        }  // link function
    };
}]).directive('parallaxBackground', ['$window', function($window) {
    return {
        restrict: 'A',
        transclude: true,
        template: '<div ng-transclude></div>',
        scope: {
            parallaxRatio: '@',
        },
        link: function($scope, elem, attrs) {
            var setPosition = function () {
                var calcValY = Math.round(elem.prop('offsetTop') - $window.pageYOffset) * ($scope.parallaxRatio ? $scope.parallaxRatio : 1.1 );
                // horizontal positioning
                elem.css('background-position', "50% " + calcValY + "px");
            };

            // set our initial position - fixes webkit background render bug
            angular.element($window).bind('load', function(e) {
                setPosition();
                $scope.$apply();
            });

            angular.element($window).bind("scroll", setPosition);
            angular.element($window).bind("touchmove", setPosition);
        }  // link function
    };
}]);
